import { NodeType } from '@reach/interfaces/nodes/node-type.enum';

export enum ClientQuotaKey {
	NODES = 'NODES',
	STORAGE = 'STORAGE',
	CHAT_KNOWLEDGE_CONVERSATIONS = 'CHAT_KNOWLEDGE_CONVERSATIONS',
	MONTHLY_CHAT_KNOWLEDGE_MESSAGES = 'MONTHLY_CHAT_KNOWLEDGE_MESSAGES',
	FILE_UPLOAD_LIMIT_IN_BYTES = 'FILE_UPLOAD_LIMIT_IN_BYTES',
	CHAT_WIDGETS = 'CHAT_WIDGETS',
	MONTHLY_CHAT_WIDGET_MESSAGES = 'MONTHLY_CHAT_WIDGET_MESSAGES',
}

export enum ClientQuotaStorageBreakdownKey {
	FILES = 'FILES',
	ALBUMS = 'ALBUMS',
	ATTACHMENTS = 'ATTACHMENTS',
}

export interface ClientQuotaBreakdownMap {
	[ClientQuotaKey.NODES]: Record<NodeType, number>;
	[ClientQuotaKey.STORAGE]: Record<ClientQuotaStorageBreakdownKey, number>;
}

export type ClientQuotaBreakdown<KEY extends ClientQuotaKey = ClientQuotaKey> =
	KEY extends keyof ClientQuotaBreakdownMap ? ClientQuotaBreakdownMap[KEY] : null;

export interface ClientQuotaItemData<KEY extends ClientQuotaKey = ClientQuotaKey> {
	used: number;
	total: number;
	available: number;

	percentage: number;
	showWarning: boolean;

	breakdown: ClientQuotaBreakdown<KEY>;
}

export interface ClientQuotaItem<KEY extends ClientQuotaKey = ClientQuotaKey> {
	key: KEY;
	data: ClientQuotaItemData<KEY>;
}

export interface ClientQuota {
	standard: Record<ClientQuotaKey, ClientQuotaItem>;
}
